const getUrl = apiPath => `${process.env.VUE_APP_API_BASE_URL}/${apiPath}`

export default {
  userLogin: getUrl('user/login'),
  userRegister: getUrl('user/register'),
  userLogout: getUrl('user/logout'),
  userList: getUrl('user/listusers'),
  requestVerifyCode: getUrl('user/resetpwrequest'),
  verifyCode: getUrl('user/resetpwverify'),
  userChangePw: getUrl('user/changepw'),
  uploadImage: getUrl('user/upload'),
  userUpdate: getUrl('user/update'),
  userDelete: getUrl('user/delete'),
  updateToken: getUrl('user/token'),
  provinceList: getUrl('province/listprovinces'),
  districtList: getUrl('district/listdistricts'),
  communeList: getUrl('commune/listcommunes'),
  zoneTypeList: getUrl('zonetype/listzonetypes'),
  zoneCreate: getUrl('zonenews/register'),
  zoneNewsList: getUrl('zonenews/listzonenews'),
  zoneDetail: getUrl('zonenews/getdetail'),
  zoneUpdate: getUrl('zonenews/update'),
  zoneDelete: getUrl('zonenews/delete'),
  estateCreate: getUrl('estatenews/register'),
  estateList: getUrl('estatenews/listestatenews'),
  estateDetail: getUrl('estatenews/getdetail'),
  estateUpdate: getUrl('estatenews/update'),
  estateDelete: getUrl('estatenews/delete'),
  userLog: getUrl('user/log'),
  settingCreate: getUrl('setting/register'),
  settingUpdate: getUrl('setting/update'),
  settingList: getUrl('setting/listsettings'),
  settingDelete: getUrl('setting/delete'),
  noticeCreate: getUrl('notice/register'),
  noticeUpdate: getUrl('notice/update'),
  noticeList: getUrl('notice/listnotices'),
  noticeDelete: getUrl('notice/delete'),
  adsList: getUrl('ads/listads'),
  adsCreate: getUrl('ads/register'),
  adsUpdate: getUrl('ads/update'),
  adsDelete: getUrl('ads/delete'),
  checkinGraph: getUrl('graph/checkin'),
  revenueGraph: getUrl('graph/revenue'),
  likeGraph: getUrl('graph/like'),
  shareGraph: getUrl('graph/share'),
  other: {
    province: {
      list: getUrl('province/listprovinces'),
      create: getUrl('province/register'),
      update: getUrl('province/update'),
      delete: getUrl('province/delete')
    },
    district: {
      list: getUrl('district/listdistricts'),
      create: getUrl('district/register'),
      update: getUrl('district/update'),
      delete: getUrl('district/delete')
    },
    commune: {
      list: getUrl('commune/listcommunes'),
      create: getUrl('commune/register'),
      update: getUrl('commune/update'),
      delete: getUrl('commune/delete')
    },
    zoneType: {
      list: getUrl('zonetype/listzonetypes'),
      create: getUrl('zonetype/register'),
      update: getUrl('zonetype/update'),
      delete: getUrl('zonetype/delete')
    },
    form: {
      list: getUrl('form/listforms'),
      create: getUrl('form/register'),
      update: getUrl('form/update'),
      delete: getUrl('form/delete')
    },
    estateType: {
      list: getUrl('type/listtypes'),
      create: getUrl('type/register'),
      update: getUrl('type/update'),
      delete: getUrl('type/delete')
    },
  }
}
